import type { SupplierPolicy } from '@tandemone/types'
import { createContext } from 'react'

/** the four policy checkboxes. licensedExporter is its own yes/no question. */
export type PolicyKey = Exclude<keyof SupplierPolicy, 'licensedExporter'>

export type PoliciesFormState = SupplierPolicy & {
  noneSelected: boolean
  submitError: string | null
}

export type PoliciesFormAction =
  | { type: 'toggle'; field: PolicyKey }
  | { type: 'selectNone' }
  | { type: 'clearNone' }
  | { type: 'setLicensedExporter'; value: boolean }
  | { type: 'submitError'; message: string | null }

export type PoliciesFormContextValue = {
  state: PoliciesFormState
  dispatch: React.Dispatch<PoliciesFormAction>
  isSubmitting: boolean
  selectedCount: number
  canSubmit: boolean
  handleSubmit: (event: React.FormEvent<HTMLFormElement>) => void
}

export const PoliciesFormContext =
  createContext<PoliciesFormContextValue | null>(null)
